// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./apps/vai_vem/~/slick-carousel/slick/slick-theme.css
// module id = 473
// module chunks = 0